import { PlatformConstantsLeander } from "@quest/oddsworks-platform";
import { ServerComm } from "@quest/platform-murka-phase_2/dist";

export class GameServerComm extends ServerComm {



    protected getPlaceBetRequest() {
        const placeBetObj: any = {};
        placeBetObj.method = PlatformConstantsLeander.PLACE_BET;
        placeBetObj.params = {};
        placeBetObj.params.bet = this.model.getTotalBet();
        placeBetObj.params.params = {};
        placeBetObj.params.params.collect = false,
            placeBetObj.params.params.collectBet = 1,
            placeBetObj.params.params.linesPlayed = this.model.getLinesPlayed();
        placeBetObj.params.type = PlatformConstantsLeander.SPIN;
        return placeBetObj;
    }
}